import { compose, prop } from 'ramda';

import { createMatchSelector } from '@/redux/router/selectors';

import { ROUTE_PATH } from './consts';
import itemsDuck from './ducks/items';
import queryDuck from './ducks/query';

export const {
  getError: getReconciliationError,
  getItemsIds: getReconciliationIds,
  getItemsMeta: getReconciliationMeta,
  getItemsTotalCount: getReconciliationTotalCount,
  isLoadingItems: isLoadingReconciliation,
} = itemsDuck.selectors;

export const { getFilters, getPage, getLimit, getSort } = queryDuck.selectors;

const getParams = createMatchSelector(ROUTE_PATH);

export const getStoreId = compose(prop('store_id'), prop('params'), getParams);
